import React, { useState, useEffect } from 'react'
import { Table, TableCell, TableRow, Typography, LinearProgress } from '@mui/material'
import { ChartBarHorizontalCustom, TableViewRowWithBars, D3StarRating, D3PieChart, D3Pie } from '../../../../components'
import { removeSpecialCharFromLhs } from '../../../../util'

import {
  TableContainerWrapper,
  TableHeadWrapper,
  TableBodyWrapper,
  TableRowWrapper,
  TableCellHead,
  ContOuterWrap,
  PieWrapper
  // ProgressBarWrapper
} from './style'

const NanoDataGridV2 = (props) => {
  const { rows, theme = 'theme1', setting = {}, overallRating } = props
  const [showBtnTrExpandIndex, setShowBtnTrExpandIndex] = useState(0)
  const [showBtnTrQuotesIndex, setShowBtnTrQuotesIndex] = useState(0)

  useEffect(() => {
    if (rows.length > 0) showBtnTrExpandQuotes()
  }, [rows])

  if (rows.length === 0) {
    return false
  }

  const maxPercentRatio = rows?.[0].Percent

  const showBtnTrExpandQuotes = () => {
    for (let e = 1; e < rows.length; e++) {
      const row = rows[e]
      if (!!row?.DriverAttributes?.length && showBtnTrExpandIndex === 0) {
        if (
          (setting?.DriverRatingImpactsValue && row?.IsHighlighted) ||
          !setting?.DriverRatingImpactsValue
        ) {
          setShowBtnTrExpandIndex(e)
          break
        }
      }
    }
    for (let e = 1; e < rows?.length; e++) {
      const row = rows[e]
      if ((!!row?.Verbatim?.length || !!row?.SearchKeywords?.length) && showBtnTrQuotesIndex === 0) {
        setShowBtnTrQuotesIndex(e)
        break
      }
    }
  }

  const isHeadingLevel1 = theme.split(' ').includes('theme1')
    ? 'headingLevel1'
    : 'headingLevel2Plus'
  const addDriverTrClass = isHeadingLevel1 === 'headingLevel1' ? 'DriversTr headerPPT' : ''

  return (
    <TableContainerWrapper className={`tableContainerWrapper ${setting?.ShowTableGrid} totalColumn${setting?.ColumnType}`}>
      <Table className={theme}>
        <TableHeadWrapper>
          <TableRow
            className={`${addDriverTrClass} tRow ${isHeadingLevel1} pptSearchKeywords_${setting?.SearchKeywords}`}
          >
  
            {setting?.ShowTableGrid === 'graph' &&  props.insightsElementType !== 'TopRelativeBrandsAnalysis' && (
              <>
                <TableCellHead className='headingTitle'>Drivers</TableCellHead>
                <TableCellHead className='headingSentiment'>{(setting?.SearchKeywords || setting?.WithoutSentiments) ? 'Engagement' : 'Sentiment'}</TableCellHead>

                {setting?.DriverRatingImpactsValue && (<TableCellHead className='headingImpactStarRating'> Impact on Star Rating</TableCellHead>)}
                {/* {setting?.DataLength?.DriverAttributeStandouts && setting?.DriverAttributeStandouts && <TableCellHead className='headingAttributes'>Attributes</TableCellHead>} */}
                {setting?.DriverAttributeStandouts && <TableCellHead className='headingAttributes'>Attributes</TableCellHead>}
                {/* {setting?.WithoutSentiments && (<TableCellHead style={{ minWidth: '10px' }} className='headingWithoutSentiments'></TableCellHead>)} */}
                {setting?.DriverSubBrandStandouts && (<TableCellHead className='headingSubBrands'> Sub-brands</TableCellHead>)}
                {setting?.DriverTriggerStandouts && (<TableCellHead className='headingTriggers'> Triggers</TableCellHead>)}
                <TableCellHead className='headingActions'></TableCellHead>
              </>
            )}

            {setting?.ShowTableGrid === 'table' && (
              <TableViewRowWithBars type='header' dataType='sentiments' data={{insightsElementType:props.insightsElementType}} settings={{...setting, showActions:true}} />
            )}

            {/* {setting?.ShowTableGrid === 'table' && (
              <>
                <TableCellHead className='headingTitle'>Drivers</TableCellHead>
                <TableCellHead className='positivePercent'>Positive</TableCellHead>
                <TableCellHead className='neutralPercent'>Neutral</TableCellHead>
                <TableCellHead className='mixedPercent'>Mixed</TableCellHead>
                <TableCellHead className='negativePercent'>Negative</TableCellHead>
                <TableCellHead className='totalPercent'>Total</TableCellHead>
                <TableCellHead width='40px' className='headingActions'>Action</TableCellHead>
              </>
            )} */}

          </TableRow>
        </TableHeadWrapper>
        <TableBodyWrapper>
          {rows.length !== 0 &&
            rows.map((row, i) => {
              return (
                <Rows
                  key={i}
                  index={i}
                  row={row}
                  theme={theme}
                  maxPercentRatio={maxPercentRatio}
                  showBtnTrExpandQuoteIndex={[showBtnTrExpandIndex, showBtnTrQuotesIndex]}
                  {...props}
                />
              )
            })}
        </TableBodyWrapper>
      </Table>
    </TableContainerWrapper>
  )
}

const Rows = ({
  index,
  row,
  action,
  showDetails = false,
  showDetailsContent,
  maxPercentRatio = 100,
  setting,
  showBtnTrExpandQuoteIndex,
  theme,
  isAppendices,
  insightsElementType,
  overallRating
}) => {
  const showBtnTrExpandIndex = index === showBtnTrExpandQuoteIndex[0] && 'showBtnTrExpandIndex'
  const showBtnTrQuotesIndex = index === showBtnTrExpandQuoteIndex[1] && 'showBtnTrQuotesIndex'
  const level1_array = row.levelIndexing?.split('_')
  const isLevel1 = level1_array?.length === 2 ? 'rowLevel1' : ''
  const addPptSubHeading = isAppendices && level1_array?.length === 2 ? 'pptSubHeading' : ''
  if (row?.Percent === 0) {
    return false
  }
  row['insightsElementType'] = insightsElementType



  const getColSpanValue = () => {
    // (insightsElementType === 'CampaignTriggers' && (row.levelIndexing.indexOf('level1_') !== -1) )?4:setting?.ColumnType
    if(insightsElementType === 'CampaignTriggers') {
      if(row.levelIndexing.indexOf('level2_') !== -1){
        return setting?.ColumnType
      }
      if(row.levelIndexing.indexOf('level1_') !== -1){
        return 4
      }
    }
    return setting?.ColumnType
  }
  
  row['id'] = index
  row['baseRating'] = (overallRating*1) // - (row?.DriverRatingImpacts?.RatingImpactAbsolute || 0)
  row['newRating'] = (overallRating*1) + (row?.DriverRatingImpacts?.RatingImpactAbsolute || 0)

  const driverRatingImpactsObject = {
    data: [
      {name: "Positive", value: row.PositivePercent},
      {name: "Negative", value: row.NegativePercent},
      {name: "Neutral", value: row.NeutralPercent},
      {name: "Mixed", value: row.MixedPercent},
    ],
    settings: {
      colors:["#00B050", "#FF0000", "#ABABAB", "#F5BD4F"],
      cx:-0.005,
      cy:-0.005,
      height:45,
      width:45,
      innerRadius:18,
      outerRadius:22,
      textCenterTitle:row.Percent+'%',
      textShow:false,
    }
  }

  return (
    <>
      <TableRowWrapper
        className={`DriversTr ${isLevel1} tRow ${row.selected ? 'selected' : 'notSelected'} ${showBtnTrExpandIndex} ${showBtnTrQuotesIndex}`}
      >
        {setting?.ShowTableGrid === 'graph' && (
          <>
            <TableCell className='headingTitle'>
              {row?.IsHighlighted && <span className='IsHighlighted'></span>}
              {row?.DriverName} {setting?.DriverRatingImpactsValue && `(${row.Percent}%)`}
              <Typography className={`hideP ${addPptSubHeading}`}>
                {row?.DriverName} {setting?.DriverRatingImpactsValue && `(${row.Percent}%)`}
              </Typography>
            </TableCell>
            <TableCell className='headingSentiment'>
              
              {setting?.DriverRatingImpactsValue
                ? <>
                  {/* DriverRatingImpactsValue */}
                  <PieWrapper positive={row.PositivePercent} negative={row.NegativePercent}>
                    <D3Pie {...driverRatingImpactsObject} />
                  </PieWrapper>
                </>
                : <>
                  {insightsElementType && <BarChartWrapper
                    row={row}
                    maxPercentRatio={maxPercentRatio}
                    fullWidth={setting?.DriverRatingImpactsValue}
                    setting={setting}
                    insightsElementType={insightsElementType}
                  />} 
                </>
              }

            </TableCell>
            {setting?.DriverRatingImpactsValue && (
              <TableCell className='headingImpactStarRating'>
                {/* aaa {row?.DriverRatingImpactsValue} bbbb */}
                {/* {console.log('row?.DriverRatingImpactsValue', row)} */}
                <D3StarRating
                  key={row.id}
                  baseRating={row.baseRating}
                  newRating={row.newRating}
                  totalStars={5}
                  width={280}
                  height={80}
                />
              </TableCell>
            )}
            <TableCell className='headingAttributes'>
              {setting?.DriverAttributeStandouts &&
                row?.DriverAttributeStandouts?.map((d, i) => (
                  <span
                    key={i}
                    className={
                      (!(
                        setting?.DriverRatingImpactsValue ||
                        setting?.SearchKeywords ||
                        setting?.WithoutSentiments
                      ) &&
                        d.Sentiment) ||
                      ''
                    }
                  >
                    {d.AttributeName}
                    {i < row.DriverAttributeStandouts.length - 1 && ','}{' '}
                  </span>
                ))}
            </TableCell>
            {setting?.DriverSubBrandStandouts && (
              <TableCell className='headingSubBrands'>
                {row?.DriverSubBrandStandouts.map((d, i) => (
                  <span key={i} className={d.Sentiment || ''}>
                    {d.SubBrandName}
                    {i < row.DriverSubBrandStandouts.length - 1 && ','}{' '}
                  </span>
                ))}
              </TableCell>
            )}
            {setting?.DriverTriggerStandouts && (
              <TableCell className='headingTriggers'>
                {row?.DriverTriggerStandouts.map((d, i) => (
                  <span key={i} className={d.Sentiment || ''}>
                    {d.TriggerName}
                    {i < row.DriverTriggerStandouts.length - 1 && ','}{' '}
                  </span>
                ))}
              </TableCell>
            )}
          </>
        )}

        {setting?.ShowTableGrid === 'table' && (
          <TableViewRowWithBars type='row' data={row} maxValue={maxPercentRatio} setting={setting} />
        )}

        {/* {setting?.ShowTableGrid === 'table' && (
          <>
            <TableCell className='headingTitle'>{row?.DriverName}</TableCell>
            <TableCellHead className='barWrap barWidth positivePercent'><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Positive }}> {row.PositivePercent}% </span><ProgressBar value={row.PositivePercent} color={LEGEND_COLOR_MAP_NEW.Positive} /></TableCellHead>
            <TableCellHead className='barWrap barWidth neutralPercent'><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Neutral }}> {row.NeutralPercent}% </span><ProgressBar value={row.NeutralPercent} color={LEGEND_COLOR_MAP_NEW.Neutral} /></TableCellHead>
            <TableCellHead className='barWrap barWidth mixedPercent'><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Mixed }}> {row.MixedPercent}% </span><ProgressBar value={row.MixedPercent} color={LEGEND_COLOR_MAP_NEW.Mixed} /></TableCellHead>
            <TableCellHead className='barWrap barWidth negativePercent'><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Negative }}> {row.NegativePercent}% </span><ProgressBar value={row.NegativePercent} color={LEGEND_COLOR_MAP_NEW.Negative} /></TableCellHead>
            <TableCellHead className='barWrap barWidth totalPercent'><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Total }}> {row.Percent}% </span><ProgressBar value={row.Percent} color={LEGEND_COLOR_MAP_NEW.Total} /></TableCellHead>
          </>
        )} */}
        
        <TableCell className='headingActions'>{React.cloneElement(action, { row })}</TableCell>
      </TableRowWrapper>

      {showDetails && row.selected && (
        <TableRowWrapper className='DriversTr___ details'>
          <TableCell colSpan={getColSpanValue()}>
            {React.cloneElement(showDetailsContent, { content: row, parentDriverName:row?.DriverName || '' })}
          </TableCell>
        </TableRowWrapper>
      )}
    </>
  )
}

const BarChartWrapper = (props) => {
  const { row, maxPercentRatio, fullWidth, setting, insightsElementType } = props
  let maxPercentRatioNew = maxPercentRatio
  if (fullWidth) {
    maxPercentRatioNew = row.Percent
  }
  const levelIndexingVal = removeSpecialCharFromLhs(row.DriverName) + removeSpecialCharFromLhs(row?.TargetSegment || '') 

  const isSpecial = !!setting?.DriverRatingImpactsValue
  const positive = isSpecial ? Math.round((row.PositivePercent / row.Percent) * 100) : Number(row.PositivePercent)
  const neutral = isSpecial ? Math.round((row.NeutralPercent / row.Percent) * 100) : Number(row.NeutralPercent)
  const mixed = isSpecial ? Math.round((row.MixedPercent / row.Percent) * 100) : Number(row.MixedPercent)
  const negative = isSpecial ? Math.round((row.NegativePercent / row.Percent) * 100) : Number(row.NegativePercent)

  return (
    <ContOuterWrap>
      {setting?.WithoutSentiments && (
        <ChartBarHorizontalCustom
          data={[{ WithoutSentiments: row.Percent }]}
          showInside={false}
          total={!fullWidth && Number(row.Percent)}
          maxPercentRatio={maxPercentRatioNew}
          valueInPercent={true}
          height='24px'
          showToolTip={false}
          // toolTipData={{...row, insightsElementType:insightsElementType, levelIndexing:levelIndexingVal}}
        />
      )}
      {setting?.SearchKeywords && (
        <ChartBarHorizontalCustom
          data={[{ SearchKeywords: row.Percent }]}
          showInside={false}
          total={!fullWidth && Number(row.Percent)}
          maxPercentRatio={maxPercentRatioNew}
          valueInPercent={true}
          height='24px'
          showToolTip={false}
          // toolTipData={{...row, insightsElementType:insightsElementType, levelIndexing:levelIndexingVal}}
        />
      )}
      {!(setting?.SearchKeywords || setting?.WithoutSentiments) && (
        <ChartBarHorizontalCustom
          data={[{ Positive: positive, Neutral: neutral, Mixed: mixed, Negative: negative }]}
          total={!fullWidth && Number(row.Percent)}
          maxPercentRatio={maxPercentRatioNew}
          valueInPercent={true}
          height='24px'
          showToolTip={false}
          toolTipData={{...row, insightsElementType:insightsElementType, levelIndexing:levelIndexingVal}}
        />
      )}
    </ContOuterWrap>
  )
}

export default NanoDataGridV2

// Reusable Progress Bar Component
// const ProgressBar = ({ value, color }) => (
//   <ProgressBarWrapper className='progressBar'>
//     <LinearProgress
//       variant='determinate'
//       value={value}
//       sx={{
//         width: 'calc(100% - 30px)',
//         mr: 1,
//         height: 6,
//         bgcolor: '#ddd',
//         '& .MuiLinearProgress-bar': { bgcolor: color },
//       }}
//     />
//     <Typography variant='body2'>{value}%</Typography>
//   </ProgressBarWrapper>
// )
